import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.service';

@Component({
  selector: 'cria-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(public userService: UserService, private router: Router) { }

  ngOnInit(): void {

    if(this.userService.hasPermission("P_SUPER_ADMIN")){
      this.router.navigate(['/pedidos'])
    }else if(this.userService.hasPermission("P_ADMIN")){
      this.router.navigate(['/pedidos'])
    }else if(this.userService.hasPermission("P_VENDEDOR")){
      this.router.navigate(['/evento/8/pedido-list'])
    }else if(this.userService.hasPermission("P_VENDEDOR_INTERNO")){
      this.router.navigate(['/evento/8/pedido-list'])
    }else if(this.userService.hasPermission("P_FABRICA")){
      this.router.navigate(['/pedidos'])
    }else if(this.userService.hasPermission("P_INVENTARIO")){
      this.router.navigate(['/inventario'])
    }else if(this.userService.hasPermission("P_PRECIFICACAO")){
      this.router.navigate(['/precificacao-criar'])
    }
  }

}
